{
  "es": {
    "messages": {
      "fleetchartScreenshot": {
        "failure": "No se pudo guardar el gráfico de flota como imagen"
      },
      "buyback": {
        "destroy": {
          "failure": "No se pudo quitar el pledge de recompra."
        }
      },
      "hangarShare": {
        "enable": {
          "success": "Enlace para compartir creado.",
          "failure": "No se pudo crear el enlace para compartir."
        },
        "rotate": {
          "success": "Enlace para compartir renovado. El enlace anterior ya no funciona.",
          "failure": "No se pudo renovar el enlace para compartir.",
          "confirm": "Al renovar el enlace, el actual dejará de funcionar. Quienes lo tengan necesitarán el nuevo enlace."
        },
        "disable": {
          "success": "Enlace para compartir eliminado.",
          "failure": "No se pudo eliminar el enlace para compartir.",
          "confirm": "Al eliminar el enlace, dejará de funcionar para todas las personas con las que lo compartiste."
        },
        "copy": {
          "success": "Enlace para compartir copiado al portapapeles.",
          "failure": "No se pudo copiar el enlace para compartir."
        }
      },
      "loading": "Cargando…",
      "copy": {
        "success": "¡Texto copiado!",
        "failure": "No se pudo copiar el texto"
      },
      "copyGitRevision": {
        "success": "¡Revisión de Git copiada!",
        "failure": "No se pudo copiar la revisión de Git"
      },
      "copyImageUrl": {
        "success": "¡URL de imagen copiada!",
        "failure": "No se pudo copiar la URL de la imagen"
      },
      "copyVideoUrl": {
        "success": "¡URL de vídeo copiada!",
        "failure": "No se pudo copiar la URL del vídeo"
      },
      "copyShareUrl": {
        "success": "¡URL \"%{url}\" copiada!",
        "failure": "No se pudo copiar la URL"
      },
      "copyInviteUrl": {
        "success": "¡URL de invitación \"%{url}\" copiada!",
        "failure": "No se pudo copiar la URL de invitación"
      },
      "copyTwoFactorProvisioningUrl": {
        "success": "¡URL de aprovisionamiento copiada!",
        "failure": "No se pudo copiar la URL de aprovisionamiento"
      },
      "copyBackupCodes": {
        "success": "¡Códigos de respaldo copiados!",
        "failure": "No se pudieron copiar los códigos de respaldo"
      },
      "signup": {
        "success": "<b>¡Bienvenido a FleetYards.net!</b> Tu cuenta ha sido creada. <br>Recibirás un email de confirmación para activar tu cuenta.",
        "invalid": "Por favor, resuelve los errores antes de que tu cuenta pueda ser creada.",
        "failure": "No pudimos crear tu cuenta. Por favor, inténtalo de nuevo más tarde."
      },
      "accountConfirm": {
        "success": "Tu cuenta fue confirmada exitosamente.<br>Ahora puedes iniciar sesión.",
        "failure": "Tu cuenta no pudo ser confirmada."
      },
      "requestPasswordChange": {
        "success": "Si tu dirección de correo electrónico existe en nuestra base de datos, recibirás un enlace de recuperación de contraseña en tu correo electrónico en unos minutos."
      },
      "changePassword": {
        "success": "Tu contraseña ha sido cambiada exitosamente.",
        "failure": "Tu contraseña no pudo ser actualizada."
      },
      "modelModule": {
        "update": {
          "failure": "No se pudo guardar el módulo."
        }
      },
      "updateProfile": {
        "success": "Perfil actualizado.",
        "failure": "Profile could not be updated."
      },
      "updateHangar": {
        "failure": "No se pudo actualizar la configuración del hangar.",
        "success": "Configuración del Hangar actualizada."
      },
      "updatePrivacy": {
        "success": "Configuración de privacidad actualizada."
      },
      "features": {
        "updated": "Función actualizada.",
        "error": "No se pudo actualizar la función.",
        "actorAdded": "Actor agregado a la función.",
        "actorRemoved": "Actor eliminado de la función.",
        "groupAdded": "Grupo agregado a la función.",
        "groupRemoved": "Grupo eliminado de la función.",
        "created": "Función creada.",
        "destroyed": "Función eliminada."
      },
      "rsiRequestLogs": {
        "resolved": "Registro de solicitud marcado como resuelto.",
        "error": "No se pudo actualizar el registro de solicitud."
      },
      "updateNotifications": {
        "success": "Configuración de Notificaciones actualizada.",
        "failure": "No se pudo guardar tu configuración de notificaciones."
      },
      "pushNotifications": {
        "failure": "No se pudieron actualizar las notificaciones push."
      },
      "updateAccount": {
        "success": "Cuenta actualizada."
      },
      "oauthApplications": {
        "create": {
          "success": "Aplicación OAuth creada.",
          "error": "No se pudo crear la aplicación OAuth."
        },
        "update": {
          "success": "Aplicación OAuth actualizada.",
          "error": "No se pudo actualizar la aplicación OAuth."
        },
        "destroy": {
          "success": "Aplicación OAuth eliminada.",
          "error": "No se pudo eliminar la aplicación OAuth."
        },
        "regenerateSecret": {
          "success": "Secreto de cliente regenerado.",
          "error": "No se pudo regenerar el secreto del cliente."
        },
        "copied": "Copiado al portapapeles.",
        "copyError": "No se pudo copiar al portapapeles.",
        "secretWarning": "Copie su secreto de cliente ahora. No podrá verlo de nuevo."
      },
      "hangarImport": {
        "success": "Importación completada",
        "partialSuccess": "Importación parcialmente completada.<br><br>Naves no encontradas: <br>%{missing}",
        "failure": "Falló la importación",
        "queued": "Importación en cola. Puedes seguirla aquí."
      },
      "hangarExport": {
        "failure": "Falló la exportación, por favor inténtalo más tarde."
      },
      "vehicle": {
        "move": {
          "failure": "No se pudo guardar el orden."
        },
        "add": {
          "success": {
            "noHtml": "Your new %{model} will be delivered to your Hangar",
            "paragraph1": "Your new ",
            "paragraph2": "will be delivered to your "
          }
        },
        "addToWishlist": {
          "success": {
            "noHtml": "Your new %{model} was added to your Wishlist",
            "paragraph2": "was added to your "
          }
        },
        "resetIngame": {
          "moveToWishlist": {
            "success": "Movidas todas las Naves compradas en el juego a tu Lista de Deseos.",
            "failure": "No se pudieron mover todas las Naves compradas en el juego a tu Lista de Deseos."
          },
          "removeAll": {
            "confirm": "¿Eliminar de tu hangar todas las naves compradas en el juego? Esta acción no se puede deshacer.",
            "success": "Eliminadas todas las Naves compradas en el juego de tu Hangar.",
            "failure": "No se pudieron eliminar todas las Naves compradas en el juego de tu Hangar."
          }
        }
      },
      "model": {
        "syncMatrixStarted": "Model matrix sync started. You will be notified when it completes.",
        "syncScDataStarted": "Model SC data sync started. You will be notified when it completes.",
        "importPaintsStarted": "Importación de pinturas iniciada. Se te avisará cuando termine.",
        "syncShipViewsStarted": "Sincronización de las vistas de la nave iniciada. Los nuevos renders aparecerán aquí cuando se procesen.",
        "dimensionsDrifted": "Estas dimensiones difieren de los archivos del juego."
      },
      "announcement": {
        "created": "Anuncio creado.",
        "updated": "Anuncio actualizado.",
        "destroyed": "Anuncio eliminado.",
        "destroyFailed": "No se pudo eliminar el anuncio.",
        "createFailed": "No se ha podido crear el anuncio.",
        "updateFailed": "No se ha podido actualizar el anuncio.",
        "testSent": "Prueba enviada al canal de Discord de administración.",
        "testFailed": "No se ha podido enviar la prueba.",
        "published": "El anuncio va en camino.",
        "publishFailed": "No se ha podido enviar el anuncio.",
        "retryQueued": "Envío puesto en cola de nuevo.",
        "retryFailed": "No se ha podido reintentar este envío.",
        "refreshQueued": "Las cifras se están actualizando.",
        "refreshFailed": "No se pudieron actualizar las cifras."
      },
      "fundingGoal": {
        "created": "Objetivo de financiación creado.",
        "updated": "Objetivo de financiación actualizado.",
        "destroyed": "Objetivo de financiación eliminado.",
        "createFailed": "No se pudo crear el objetivo de financiación.",
        "updateFailed": "No se pudo actualizar el objetivo de financiación."
      },
      "supporterNomination": {
        "update": {
          "success": "Selección de flota actualizada.",
          "failure": "No se ha podido actualizar la selección de flota."
        },
        "change": {
          "confirm": "%{fleet} puede perder las funciones de flota que tiene ahora. ¿Continuar?"
        }
      },
      "supporterContribution": {
        "created": "Aportación de patrocinador creada.",
        "updated": "Aportación de patrocinador actualizada.",
        "destroyed": "Aportación de patrocinador eliminada.",
        "createFailed": "No se pudo crear la aportación de patrocinador.",
        "updateFailed": "No se pudo actualizar la aportación de patrocinador."
      },
      "notification": {
        "granted": "¡Bienvenido a las Notificaciones de FleetYards.net!"
      },
      "twoFactor": {
        "enable": {
          "success": "¡Autenticación de dos factores activada!",
          "failure": "No se pudo activar la Autenticación de dos factores."
        },
        "disable": {
          "success": "¡Autenticación de dos factores desactivada!",
          "failure": "No se pudo desactivar la Autenticación de dos factores."
        },
        "backupCodes": {
          "failure": "No se pudieron generar los Códigos de respaldo."
        }
      },
      "error": {
        "usernameTaken": "El nombre de usuario ya está tomado.",
        "userNotFound": "Usuario no encontrado",
        "emailTaken": "El email ya está tomado.",
        "fleetTaken": "La flota ya está tomada.",
        "colorInvalid": "Color is invalid",
        "serialTaken": "El número de serie ya está tomado.",
        "textInvalid": "%{field} es inválido",
        "fleetNameInvalid": "El campo %{field} solo puede contener caracteres alfanuméricos, espacios, puntos, guiones y guiones bajos",
        "vehicleSerialInvalid": "El campo %{field} debe tener el formato del registro que muestra el juego, por ejemplo L8-4261-HA",
        "hangar": {
          "accountRequired": {
            "noHtml": "You need to Sign up or Login to add Ships to your Hangar.",
            "paragraph1": "You need to ",
            "paragraph2": " to add Ships to your Hangar.",
            "paragraph3": "Get more Information "
          }
        },
        "blueprint": {
          "accountRequired": "Regístrate o inicia sesión para llevar la cuenta de tus planos.",
          "own": "No pudimos actualizar ese plano. Inténtalo de nuevo."
        },
        "default": "<b>Algo salió mal.</b> <br>¿Has intentado apagarlo y volverlo a encender?"
      },
      "account": {
        "destroy": {
          "success": "<b>Tu cuenta ha sido eliminada.</b> <br>Es triste verte partir :'(",
          "failure": "¡No pudimos eliminar tu cuenta! Por favor inténtalo más tarde."
        },
        "calendarSubscription": {
          "enable": {
            "success": "Suscripción al calendario personal activada.",
            "failure": "No se pudo activar la suscripción al calendario."
          },
          "rotate": {
            "success": "Enlace del calendario personal rotado. Los suscriptores actuales dejarán de recibir actualizaciones hasta que vuelvan a suscribirse.",
            "failure": "No se pudo rotar el enlace del calendario personal.",
            "confirm": "Rotar el enlace invalidará silenciosamente cualquier aplicación de calendario suscrita a la URL actual. Tendrás que volver a suscribirte con el nuevo enlace."
          },
          "disable": {
            "success": "Suscripción al calendario personal desactivada.",
            "failure": "No se pudo desactivar la suscripción al calendario personal.",
            "confirm": "Desactivar la suscripción cortará el feed para cualquier aplicación de calendario suscrita actualmente."
          }
        },
        "supporterClaimKey": {
          "copy": {
            "success": "Clave copiada.",
            "failure": "No se pudo copiar la clave."
          }
        }
      },
      "user": {
        "destroy": {
          "success": "Usuario eliminado.",
          "failure": "No se pudo eliminar el usuario."
        }
      },
      "fleet": {
        "fidClaim": {
          "create": {
            "success": "Reclamación abierta. Se ha avisado a la flota que tiene el ID.",
            "failure": "No se pudo reclamar el ID de flota."
          },
          "destroy": {
            "success": "Reclamación retirada.",
            "failure": "No se pudo retirar la reclamación."
          },
          "endNow": {
            "success": "Periodo de gracia terminado.",
            "failure": "No se pudo terminar el periodo de gracia."
          },
          "cancel": {
            "success": "Reclamación cancelada.",
            "failure": "No se pudo cancelar la reclamación."
          }
        },
        "create": {
          "success": "Tu Flota ha sido creada.",
          "failure": "La Flota no pudo ser guardada."
        },
        "update": {
          "success": "Configuración guardada.",
          "failure": "La configuración no pudo ser guardada."
        },
        "destroy": {
          "success": "Tu Flota ha sido destruida.",
          "failure": "No pudimos destruir tu Flota."
        },
        "leave": {
          "success": "Has abandonado la Flota.",
          "failure": "No se pudo abandonar la Flota."
        },
        "invites": {
          "accept": {
            "success": "Invitación aceptada.",
            "failure": "No se pudo aceptar la Invitación."
          },
          "decline": {
            "success": "Invitación rechazada.",
            "failure": "No se pudo rechazar la Invitación."
          },
          "create": {
            "failure": "No se pudo invitar al Usuario."
          }
        },
        "members": {
          "update": {
            "success": "Configuración guardada.",
            "failure": "La configuración no pudo ser guardada."
          },
          "destroy": {
            "success": "Miembro eliminado.",
            "failure": "El miembro no pudo ser eliminado."
          },
          "demote": {
            "success": "Miembro degradado.",
            "failure": "El miembro no pudo ser degradado."
          },
          "promote": {
            "success": "Miembro promovido.",
            "failure": "El miembro no pudo ser promovido."
          },
          "accept": {
            "success": "Miembro aceptado.",
            "failure": "El miembro no pudo ser aceptado."
          },
          "decline": {
            "success": "Miembro rechazado.",
            "failure": "El miembro no pudo ser rechazado."
          },
          "nickname": {
            "success": "Apodo guardado.",
            "failure": "No se pudo guardar el apodo."
          }
        },
        "roles": {
          "update": {
            "success": "Rol guardado.",
            "failure": "No se pudo guardar el rol."
          }
        },
        "squadrons": {
          "create": {
            "success": "Escuadrón creado.",
            "failure": "No se ha podido crear el escuadrón."
          },
          "update": {
            "success": "Escuadrón guardado.",
            "failure": "No se ha podido guardar el escuadrón."
          },
          "destroy": {
            "confirm": "¿Disolver el escuadrón «%{name}»? Sus miembros seguirán en la flota.",
            "success": "Escuadrón disuelto.",
            "failure": "No se ha podido disolver el escuadrón."
          },
          "sort": {
            "failure": "No se pudo guardar el orden."
          },
          "ranks": {
            "update": {
              "success": "Rangos de escuadrón guardados.",
              "failure": "No se pudieron guardar los rangos de escuadrón."
            }
          },
          "members": {
            "add": {
              "success": "%{count} miembros añadidos.",
              "failure": "No se han podido añadir %{count} miembros."
            },
            "destroy": {
              "confirm": "¿Quitar a %{username} del escuadrón %{squadron}? Seguirá en la flota.",
              "success": "Miembro quitado del escuadrón.",
              "failure": "No se pudo quitar al miembro."
            }
          },
          "join": {
            "success": "Te has unido al equipo.",
            "failure": "No se pudo unir al equipo."
          },
          "leave": {
            "confirm": "¿Salir del escuadrón %{squadron}? Seguirás en la flota.",
            "success": "Has salido del escuadrón.",
            "failure": "No se pudo salir del escuadrón."
          },
          "requests": {
            "create": {
              "success": "Solicitud enviada. Los líderes del escuadrón la responderán.",
              "failure": "No se pudo enviar la solicitud."
            },
            "withdraw": {
              "success": "Solicitud retirada.",
              "failure": "No se pudo retirar la solicitud."
            },
            "blocked": {
              "member": "Ya estás en %{squadron}. Sal de él antes de pedir unirte a otro escuadrón.",
              "requested": "Pediste unirte a %{squadron}. Retira esa solicitud antes de pedir otro escuadrón."
            },
            "accept": {
              "success": "%{username} se ha unido al escuadrón.",
              "failure": "No se pudo aceptar la solicitud."
            },
            "decline": {
              "success": "Solicitud rechazada.",
              "failure": "No se pudo rechazar la solicitud."
            }
          },
          "rank": {
            "success": "Rango cambiado.",
            "failure": "No se pudo cambiar el rango."
          }
        },
        "calendarSubscription": {
          "enable": {
            "success": "Suscripción al calendario activada.",
            "failure": "No se pudo activar la suscripción al calendario."
          },
          "rotate": {
            "success": "Enlace de suscripción rotado. Los suscriptores actuales dejarán de recibir actualizaciones hasta que vuelvan a suscribirse.",
            "failure": "No se pudo rotar el enlace de suscripción.",
            "confirm": "Rotar el enlace invalidará silenciosamente cualquier aplicación de calendario suscrita a la URL actual. Tendrán que volver a suscribirse con el nuevo enlace."
          },
          "disable": {
            "success": "Suscripción al calendario desactivada.",
            "failure": "No se pudo desactivar la suscripción al calendario.",
            "confirm": "Desactivar la suscripción cortará el feed para cualquier aplicación de calendario suscrita actualmente."
          },
          "copy": {
            "success": "Enlace del calendario copiado. Pégalo en tu aplicación de calendario en \"Suscribirse al calendario\" o \"Añadir por URL\".",
            "failure": "No se pudo copiar el enlace del calendario."
          }
        }
      },
      "fleetInvite": {
        "used": "<b>¡Solicitud de unión para %{fleet} enviada!</b><br>Una vez que tu membresía sea aceptada serás notificado por email",
        "failure": "La invitación no pudo ser utilizada.",
        "confirm": "¿Estás seguro de que quieres unirte a la Flota: \"%{fleet}\"?"
      },
      "holoViewer": {
        "modelLoader": {
          "failure": "¡No pudimos cargar el modelo 3D solicitado! Por favor inténtalo más tarde."
        },
        "webglNotSupported": "El visor 3D no está disponible en este dispositivo.",
        "tooLarge": "Este modelo 3D ocupa %{size} MB y puede ser demasiado grande para este dispositivo."
      },
      "cargoGridViewer": {
        "confirmReset": "Are you sure you want to reset all ships and container settings?"
      },
      "confirm": {
        "vehicleLoadout": {
          "moduleContents": {
            "one": "La pieza montada en este módulo se va con él.",
            "other": "Las %{count} piezas montadas en este módulo se van con él."
          }
        },
        "vehicle": {
          "destroy": "¿Estás seguro de que quieres eliminar esta Nave de tu Hangar?"
        },
        "buyback": {
          "destroy": "¿Quitar este pledge de tu lista de recompra? Úsalo después de recomprarlo en RSI. La próxima sincronización lo recupera si sigue en la lista allí."
        },
        "hangarGroup": {
          "destroy": "¿Estás seguro de que quieres eliminar este Grupo de tu Hangar?"
        },
        "hangar": {
          "import": "Las naves importadas se añadirán a tu Hangar sin coincidir con las Naves existentes.<br><br>Los formatos soportados son: Exportación de Fleetyards o HangarXplor.<br><br>¿Quieres continuar?",
          "destroySelected": "¿Estás seguro de que quieres eliminar todas las Naves Seleccionadas de tu Hangar? Esta acción no se puede revertir.",
          "destroyAll": "¿Estás seguro de que quieres eliminar todas las Naves de tu Hangar? Esta acción no se puede revertir.",
          "destroyAllTitle": "¿Eliminar todas las naves?"
        },
        "wishlist": {
          "destroyAll": "¿Estás seguro de que quieres eliminar todas las Naves de tu Lista de Deseos? Esta acción no se puede revertir."
        },
        "account": {
          "destroy": "¿Estás seguro de que quieres destruir tu Cuenta? Esta acción no se puede revertir.",
          "destroyWithFleets": "Eres el administrador de las siguientes flotas: %{fleets}. Eliminar tu cuenta también destruirá estas flotas y expulsará a todos sus miembros. Esta acción no se puede revertir. ¿Continuar?"
        },
        "itemPrice": {
          "destroy": "Are you sure you want to destroy this Item Price? This Action can't be reverted."
        },
        "fleet": {
          "leave": "¿Estás seguro de que quieres abandonar la Flota? Esta acción no se puede revertir.",
          "destroy": "¿Estás seguro de que quieres destruir tu Flota? Esta acción no se puede revertir.",
          "members": {
            "destroy": "¿Estás seguro de que quieres eliminar este Miembro?",
            "remove": "¿Seguro que quieres eliminar a este miembro de la flota?"
          },
          "invites": {
            "decline": "¿Estás seguro de que quieres rechazar esta Invitación? Esta acción no se puede revertir."
          }
        },
        "oauthApplication": {
          "destroy": "¿Está seguro de que desea eliminar esta aplicación OAuth? Esta acción no se puede revertir.",
          "regenerateSecret": "¿Está seguro de que desea regenerar el secreto del cliente? Las integraciones existentes dejarán de funcionar."
        },
        "twoFactor": {
          "generateBackupCodes": "¿Estás seguro de que quieres regenerar tus Códigos de Respaldo de Autenticación de dos factores?"
        },
        "user": {
          "loginAs": "Are you sure you want to login as this user?",
          "resendConfirmation": "Are you sure you want to resend the confirmation email for this user?",
          "sendPasswordReset": "Are you sure you want to send a password reset email for this user?",
          "destroy": "Are you sure you want to delete this user? This action can't be reverted.",
          "destroyWithFleets": "Este usuario es el administrador de las siguientes flotas: %{fleets}. Eliminar al usuario también destruirá estas flotas y expulsará a todos sus miembros. Esta acción no se puede revertir. ¿Continuar?"
        },
        "model": {
          "destroy": "Are you sure you want to delete this model? This action can't be reverted.",
          "sync": "Are you sure you want to sync this model from RSI?",
          "syncMatrix": "Are you sure you want to sync the ship matrix data for this model?",
          "syncScData": "Are you sure you want to sync the SC data for this model?",
          "importPaints": "¿Seguro que quieres importar las pinturas de este modelo desde los datos del hangar? Una pintura que la fuente asigna a toda una serie se importa para todos los modelos de esa serie.",
          "syncShipViews": "¿Seguro que quieres sincronizar las vistas de la nave de este modelo desde el bucket de renders? Se adjuntan los renders nuevos y modificados, y los eliminados vuelven. Una vista subida a mano sobre un render importado se conserva.",
          "exchangeStoreImage": "Are you sure you want to replace the store image with the RSI image?",
          "reloadMatrix": "Are you sure you want to reload the models matrix? This will enqueue background jobs.",
          "reloadScData": "Are you sure you want to reload SC data? This will enqueue background jobs.",
          "reloadPaints": "¿Seguro que quieres recargar las pinturas? Esto encolará trabajos en segundo plano.",
          "reloadModules": "¿Seguro que quieres recargar los módulos? Esto encolará trabajos en segundo plano.",
          "reloadLoaners": "¿Seguro que quieres recargar las naves prestadas? Esto encolará trabajos en segundo plano."
        },
        "manufacturer": {
          "destroy": "Are you sure you want to delete this manufacturer? This action can't be reverted."
        },
        "announcement": {
          "publish": "¿Enviar este anuncio a %{channels}? No se puede deshacer.",
          "destroy": "¿Está seguro de que desea eliminar este anuncio? Esta acción no se puede deshacer."
        },
        "fundingGoal": {
          "destroy": "¿Seguro que quieres eliminar este objetivo de financiación? Esta acción no se puede revertir."
        },
        "supporterContribution": {
          "destroy": "¿Seguro que quieres eliminar esta aportación de patrocinador? Esta acción no se puede revertir."
        },
        "modelPosition": {
          "destroy": "¿Seguro que quieres eliminar esta posición? Esta acción no se puede revertir."
        },
        "modelLoaner": {
          "destroy": "¿Está seguro de que desea eliminar este préstamo? Esta acción no se puede revertir."
        },
        "modelSnubCraft": {
          "destroy": "¿Seguro que quieres eliminar este snub craft? Esta acción no se puede revertir."
        },
        "modelPaint": {
          "destroy": "Are you sure you want to delete this paint? This action can't be reverted."
        },
        "video": {
          "destroy": "Are you sure you want to delete this video? This action can't be reverted."
        },
        "modelModule": {
          "destroy": "Are you sure you want to delete this module? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this module from the model? The module will still exist but won't be associated with this model."
        },
        "modelUpgrade": {
          "destroy": "Are you sure you want to delete this upgrade? This action can't be reverted.",
          "unlink": "Are you sure you want to unlink this upgrade from the model? The upgrade will still exist but won't be associated with this model."
        },
        "modelModulePackage": {
          "destroy": "Are you sure you want to delete this module package? This action can't be reverted."
        },
        "dockCapacity": {
          "destroy": "¿Seguro que quieres eliminar esta entrada de capacidad? Esta acción no se puede deshacer."
        },
        "dock": {
          "destroy": "Are you sure you want to delete this dock? This action can't be reverted."
        },
        "component": {
          "destroy": "Are you sure you want to delete this component? This action can't be reverted."
        },
        "adminFleet": {
          "destroy": "Are you sure you want to delete this fleet? This action can't be reverted."
        },
        "adminNotifications": {
          "destroyAll": "¿Seguro que quieres borrar todas las notificaciones? Esta acción no se puede revertir.",
          "destroySelected": {
            "one": "¿Seguro que quieres borrar la notificación seleccionada? Esta acción no se puede revertir.",
            "other": "¿Seguro que quieres borrar las %{count} notificaciones seleccionadas? Esta acción no se puede revertir."
          }
        },
        "adminFleetFidClaim": {
          "endNow": "¿Terminar ya el periodo de gracia? La flota que lo tiene cambia de nombre y la que reclama recibe el ID de flota al momento.",
          "cancel": "¿Cancelar esta reclamación? Se avisa a ambas flotas, y la que lo tiene conserva el ID de flota."
        },
        "fleetFidClaim": {
          "create": "¿Reclamar el ID de flota %{fid}? Se avisa ahora a la flota que lo tiene, y lo pierde en 14 días salvo que demuestre ella misma la organización de RSI."
        },
        "adminDestroyedFleet": {
          "restore": "¿Seguro que quieres restaurar esta flota?",
          "restorePurged": "¿Seguro que quieres restaurar esta flota purgada? La restauración se hace en la medida de lo posible: los roles, las imágenes, los enlaces de invitación y los vehículos de la flota no se restauran."
        },
        "adminUser": {
          "destroy": "Are you sure you want to delete this admin user? This action can't be reverted."
        },
        "image": {
          "destroy": "Are you sure you want to delete this image? This action can't be reverted."
        },
        "adminVehicle": {
          "destroy": "Are you sure you want to delete this vehicle? This action can't be reverted."
        },
        "commodity": {
          "destroy": "Are you sure you want to delete this commodity? This action can't be reverted."
        },
        "equipment": {
          "destroy": "Are you sure you want to delete this equipment? This action can't be reverted."
        },
        "notifications": {
          "destroyAll": "¿Seguro que quieres borrar todas las notificaciones? Esta acción no se puede revertir.",
          "destroySelected": {
            "one": "¿Seguro que quieres borrar la notificación seleccionada? Esta acción no se puede revertir.",
            "other": "¿Seguro que quieres borrar las %{count} notificaciones seleccionadas? Esta acción no se puede revertir."
          }
        },
        "unlistedModel": {
          "createModel": "¿Crear una nave a partir de %{name}? La próxima carga de sc_data rellenará su mecánica."
        },
        "import": {
          "cleanup": "¿Marcar esta importación como fallida? Hazlo solo si el trabajo ya no existe: una ejecución que siga activa fallará al terminar.",
          "cleanupSelected": "¿Marcar como fallidas las importaciones seleccionadas? Solo afecta a las que siguen en curso, y una ejecución que siga realmente activa fallará al terminar.",
          "cancel": "¿Detener esta importación? Las naves ya añadidas se conservan."
        },
        "hardpoint": {
          "destroy": "¿Seguro que quieres eliminar este punto de montaje? Esta acción no se puede revertir."
        },
        "fleets": {
          "contractItem": {
            "destroy": "¿Quitar estas mercancías del contrato?"
          }
        },
        "vehicleLog": {
          "destroy": "¿Seguro que quieres eliminar esta entrada de bitácora?"
        }
      },
      "oauthAuthorize": {
        "loading": "Cargando...",
        "loadError": "Error al cargar los detalles de autorización.",
        "authorizeError": "Autorización fallida.",
        "denyError": "La denegación de autorización falló."
      },
      "oauth": {
        "disconnect": {
          "success": "Proveedor desconectado exitosamente.",
          "failure": "No se pudo desconectar el proveedor. Inténtelo de nuevo."
        }
      },
      "confirmAccess": {
        "failure": "No se pudo confirmar el acceso. Verifique su contraseña e intente nuevamente."
      },
      "setEmail": {
        "success": "Se ha enviado un correo de confirmación a tu nueva dirección. Por favor, revisa tu bandeja de entrada.",
        "failure": "No se pudo actualizar la dirección de correo. Por favor, inténtalo de nuevo."
      },
      "confirmAccessEmail": {
        "sent": "Se ha enviado un código de confirmación a su correo electrónico.",
        "failure": "No se pudo enviar el correo de confirmación. Inténtelo de nuevo."
      },
      "confirmAccessCode": {
        "failure": "El código de confirmación es inválido o ha expirado."
      },
      "import": {
        "started": "Importación de %{type} iniciada...",
        "finished": "Importación de %{type} completada exitosamente.",
        "failed": "Importación de %{type} fallida: %{info}"
      },
      "buybackSync": {
        "started": "Sincronizando tus pledges de recompra...",
        "success": "Tus pledges de recompra se han sincronizado.",
        "failure": "No se pudieron sincronizar tus pledges de recompra.",
        "detailsSuccess": "Los precios y seguros de tus pledges de recompra están actualizados."
      },
      "syncExtension": {
        "started": "Sincronizando tu Hangar...",
        "success": "Tu Hangar ha sido sincronizado.",
        "failure": "Tu Hangar no pudo ser sincronizado.",
        "cancelled": "La sincronización del hangar se ha cancelado.",
        "pageNotRecognised": "La página de RSI tiene un aspecto distinto al que FleetYards espera, así que la sincronización se detuvo sin cambiar nada.",
        "nothingToSync": "FleetYards no encontró naves, pinturas ni componentes en tu hangar de RSI, así que no se cambió nada.",
        "onlySkippedItems": "Tu hangar de RSI solo contiene pinturas o decoración de hangar, que esta sincronización está configurada para omitir, así que no se cambió nada.",
        "nothingReadable": "Algunos elementos de tu hangar de RSI no se pudieron leer y FleetYards no encontró nada más, así que no se cambió nada.",
        "notLoggedIn": "Necesitas estar conectado en <a href=\"https://robertsspaceindustries.com\" target=\"_blank\">https://robertsspaceindustries.com</a> para sincronizar tu Hangar."
      },
      "admin": {
        "form": {
          "created": "Creado.",
          "updated": "Cambios guardados."
        },
        "importLoaders": {
          "started": "%{name} iniciado.",
          "failed": "No se pudo iniciar %{name}."
        },
        "supporterContributions": {
          "patreonSyncStarted": "Sincronización con Patreon iniciada. Actualiza en un minuto para ver los patrocinadores importados."
        },
        "imports": {
          "cleaned": "Importación marcada como fallida",
          "cleanedUp": {
            "one": "%{count} importación marcada como fallida",
            "other": "%{count} importaciones marcadas como fallidas"
          },
          "noneRunning": "Nada de la selección seguía en curso",
          "cleanupError": "No se pudo limpiar la importación"
        }
      },
      "logistics": {
        "request": {
          "create": {
            "success": "Logistics request created.",
            "failure": "Could not create logistics request."
          }
        },
        "inventory": {
          "create": {
            "success": "Inventory created.",
            "failure": "Could not create inventory."
          },
          "update": {
            "success": "Inventory updated.",
            "failure": "Could not update inventory."
          },
          "destroy": {
            "success": "Inventory deleted.",
            "failure": "Could not delete inventory."
          }
        },
        "inventoryItem": {
          "create": {
            "success": "Item added to inventory.",
            "failure": "Could not add item to inventory."
          },
          "deposit": {
            "success": "Deposit recorded.",
            "failure": "Could not record deposit."
          },
          "withdrawal": {
            "success": "Withdrawal recorded.",
            "failure": "Could not record withdrawal. Check available stock."
          },
          "destroy": {
            "success": "Entry deleted.",
            "failure": "Could not delete entry.",
            "confirm": "Delete this entry? The stock it added or removed is corrected accordingly."
          }
        },
        "comment": {
          "create": {
            "success": "Comment added.",
            "failure": "Could not add comment."
          }
        },
        "csvImport": {
          "success": "%{count} items imported successfully.",
          "failure": "Could not import CSV file."
        },
        "stockItem": {
          "update": {
            "success": "Item updated.",
            "failure": "Could not update item."
          },
          "destroy": {
            "success": "Item deleted.",
            "failure": "Could not delete item.",
            "confirm": "Delete this item and all %{count} of its entries? This cannot be undone."
          }
        },
        "vehicleInventory": {
          "clear": {
            "confirm": "¿Vaciar la carga de esta nave? Se eliminarán todas las entradas.",
            "success": "Carga vaciada.",
            "failure": "No se pudo vaciar la carga."
          }
        },
        "transfer": {
          "needsAnswer": "Deben aceptarlo antes de que llegue. Las existencias salen de tu inventario ahora y vuelven si lo rechazan.",
          "create": {
            "failure": "No se pudo enviar la transferencia"
          },
          "resolve": {
            "failure": "No se pudo actualizar la transferencia"
          },
          "reportHint": "Denunciar lo rechaza, devuelve la mercancía e impide que este remitente vuelva a contactarte."
        }
      },
      "adminNotifications": {
        "read": "Notificación marcada como leída",
        "unread": "Notificación marcada como no leída",
        "archived": "Notificación archivada",
        "unarchived": "Notificación devuelta a la bandeja de entrada",
        "readAll": "Todas las notificaciones marcadas como leídas",
        "destroyed": "Notificación eliminada",
        "destroyedAll": "Todas las notificaciones eliminadas",
        "error": "Algo salió mal",
        "bulk": {
          "read": {
            "one": "%{count} notificación marcada como leída",
            "other": "%{count} notificaciones marcadas como leídas"
          },
          "unread": {
            "one": "%{count} notificación marcada como no leída",
            "other": "%{count} notificaciones marcadas como no leídas"
          },
          "archived": {
            "one": "%{count} notificación archivada",
            "other": "%{count} notificaciones archivadas"
          },
          "unarchived": {
            "one": "%{count} notificación devuelta a la bandeja de entrada",
            "other": "%{count} notificaciones devueltas a la bandeja de entrada"
          },
          "destroyed": {
            "one": "%{count} notificación eliminada",
            "other": "%{count} notificaciones eliminadas"
          }
        }
      },
      "fleets": {
        "notifications": {
          "update": {
            "success": "Configuración de notificaciones guardada.",
            "failure": "No se pudo guardar la configuración de notificaciones."
          }
        },
        "mission": {
          "publish": {
            "success": "Misión publicada: la flota ya puede verla.",
            "failure": "No se pudo publicar la misión."
          },
          "create": {
            "success": "Misión creada.",
            "failure": "No se pudo crear la misión."
          },
          "update": {
            "success": "Misión actualizada.",
            "failure": "No se pudo actualizar la misión."
          },
          "archive": {
            "success": "Misión archivada.",
            "failure": "No se pudo archivar la misión."
          },
          "unarchive": {
            "success": "Misión restaurada.",
            "failure": "No se pudo restaurar la misión."
          },
          "destroy": {
            "success": "Misión eliminada.",
            "failure": "No se pudo eliminar la misión.",
            "confirm": "Esto eliminará permanentemente la misión y todos sus equipos, naves y slots. Esta acción no se puede deshacer."
          }
        },
        "missionTeam": {
          "create": {
            "success": "Equipo añadido.",
            "failure": "No se pudo añadir el equipo."
          },
          "update": {
            "success": "Equipo actualizado.",
            "failure": "No se pudo actualizar el equipo."
          },
          "destroy": {
            "success": "Equipo eliminado.",
            "failure": "No se pudo eliminar el equipo."
          }
        },
        "missionShip": {
          "create": {
            "success": "Nave añadida.",
            "failure": "No se pudo añadir la nave."
          },
          "update": {
            "success": "Nave actualizada.",
            "failure": "No se pudo actualizar la nave."
          },
          "destroy": {
            "success": "Nave eliminada.",
            "failure": "No se pudo eliminar la nave."
          },
          "duplicate": {
            "success": "Nave duplicada.",
            "failure": "No se pudo duplicar la nave."
          }
        },
        "missionSlot": {
          "create": {
            "success": "Slot añadido.",
            "failure": "No se pudo añadir el slot."
          },
          "update": {
            "success": "Slot actualizado.",
            "failure": "No se pudo actualizar el slot."
          },
          "destroy": {
            "success": "Slot eliminado.",
            "failure": "No se pudo eliminar el slot."
          }
        },
        "event": {
          "create": {
            "success": "Evento creado.",
            "failure": "No se pudo crear el evento."
          },
          "update": {
            "success": "Evento actualizado.",
            "failure": "No se pudo actualizar el evento."
          },
          "archive": {
            "success": "Evento archivado.",
            "failure": "No se pudo archivar el evento.",
            "confirm": "¿Archivar este evento? Los miembros dejarán de verlo en la lista de próximos."
          },
          "unarchive": {
            "success": "Evento restaurado del archivo.",
            "failure": "No se pudo restaurar el evento."
          },
          "syncToDiscord": {
            "success": "Evento enviado a Discord.",
            "failure": "No se pudo enviar el evento a Discord."
          },
          "destroy": {
            "success": "Evento eliminado.",
            "failure": "No se pudo eliminar el evento.",
            "confirm": "Esto eliminará permanentemente el evento. Esta acción no se puede deshacer."
          },
          "publish": {
            "success": "Evento publicado — las inscripciones ya están abiertas.",
            "failure": "No se pudo publicar el evento."
          },
          "lockSignups": {
            "success": "Inscripciones bloqueadas.",
            "failure": "No se pudieron bloquear las inscripciones."
          },
          "unlockSignups": {
            "success": "Inscripciones reabiertas.",
            "failure": "No se pudieron reabrir las inscripciones."
          },
          "start": {
            "success": "Evento iniciado.",
            "failure": "No se pudo iniciar el evento."
          },
          "complete": {
            "success": "Evento marcado como completado.",
            "failure": "No se pudo completar el evento."
          },
          "cancel": {
            "success": "Evento cancelado.",
            "failure": "No se pudo cancelar el evento.",
            "confirm": "¿Cancelar este evento? Se notificará a los participantes."
          }
        },
        "eventSignup": {
          "create": {
            "success": "Te has inscrito.",
            "failure": "No se pudo completar la inscripción."
          },
          "update": {
            "success": "Inscripción actualizada.",
            "failure": "No se pudo actualizar la inscripción."
          },
          "withdraw": {
            "success": "Te has retirado del evento.",
            "failure": "No se pudo completar la retirada.",
            "confirm": "¿Retirarte de este evento?"
          },
          "kick": {
            "success": "Inscripción eliminada.",
            "failure": "No se pudo eliminar la inscripción.",
            "confirm": "¿Eliminar la inscripción de este miembro?"
          }
        },
        "eventAdmin": {
          "create": {
            "success": "Rol concedido.",
            "failure": "No se pudo conceder el rol."
          },
          "destroy": {
            "success": "Rol revocado.",
            "failure": "No se pudo revocar el rol.",
            "confirm": "¿Revocar el rol de %{username} para este evento?"
          }
        },
        "eventTeam": {
          "create": {
            "success": "Equipo añadido.",
            "failure": "No se pudo añadir el equipo."
          },
          "update": {
            "success": "Equipo actualizado.",
            "failure": "No se pudo actualizar el equipo."
          },
          "destroy": {
            "success": "Equipo eliminado.",
            "failure": "No se pudo eliminar el equipo.",
            "confirm": "¿Eliminar este equipo y todas sus naves y slots?"
          }
        },
        "eventShip": {
          "create": {
            "success": "Nave añadida.",
            "failure": "No se pudo añadir la nave."
          },
          "update": {
            "success": "Nave actualizada.",
            "failure": "No se pudo actualizar la nave."
          },
          "destroy": {
            "success": "Nave eliminada.",
            "failure": "No se pudo eliminar la nave.",
            "confirm": "¿Eliminar esta nave y sus slots?"
          }
        },
        "eventSlot": {
          "create": {
            "success": "Slot añadido.",
            "failure": "No se pudo añadir el slot."
          },
          "update": {
            "success": "Slot actualizado.",
            "failure": "No se pudo actualizar el slot."
          },
          "destroy": {
            "success": "Slot eliminado.",
            "failure": "No se pudo eliminar el slot."
          }
        },
        "contract": {
          "create": {
            "success": "Contrato creado",
            "failure": "No se pudo crear el contrato"
          },
          "update": {
            "success": "Contrato guardado",
            "failure": "No se pudo guardar el contrato"
          },
          "item": {
            "create": {
              "failure": "No se pudieron añadir las mercancías"
            },
            "destroy": {
              "failure": "No se pudieron quitar las mercancías"
            },
            "update": {
              "failure": "No se han podido cambiar las mercancías"
            }
          }
        },
        "contracts": {
          "deliverHint": "Envía las mercancías desde uno de tus inventarios y elige este contrato para que la entrega cuente.",
          "expiredHint": "Este contrato ha caducado y no admite nuevas entregas. Las entregas que ya están en camino siguen contando cuando se aceptan."
        }
      },
      "notifications": {
        "read": "Notificación marcada como leída",
        "unread": "Notificación marcada como no leída",
        "archived": "Notificación archivada",
        "unarchived": "Notificación devuelta a la bandeja de entrada",
        "readAll": "Todas las notificaciones marcadas como leídas",
        "destroyed": "Notificación eliminada",
        "destroyedAll": "Todas las notificaciones eliminadas",
        "actionDone": "Hecho",
        "actionFailed": "Eso no funcionó: puede que la notificación esté desactualizada",
        "error": "Algo salió mal",
        "bulk": {
          "read": {
            "one": "%{count} notificación marcada como leída",
            "other": "%{count} notificaciones marcadas como leídas"
          },
          "unread": {
            "one": "%{count} notificación marcada como no leída",
            "other": "%{count} notificaciones marcadas como no leídas"
          },
          "archived": {
            "one": "%{count} notificación archivada",
            "other": "%{count} notificaciones archivadas"
          },
          "unarchived": {
            "one": "%{count} notificación devuelta a la bandeja de entrada",
            "other": "%{count} notificaciones devueltas a la bandeja de entrada"
          },
          "destroyed": {
            "one": "%{count} notificación eliminada",
            "other": "%{count} notificaciones eliminadas"
          }
        }
      },
      "imports": {
        "cancel": {
          "success": "Importación cancelada",
          "error": "No se pudo cancelar esta importación"
        }
      },
      "payouts": {
        "participantAddedUser": "%{name} añadido con su cuenta de FleetYards",
        "participantAddedGuest": "%{name} añadido como invitado",
        "invalidAmount": "Introduce un importe, p. ej. 1.500,50",
        "currencyUpdated": "Moneda actualizada",
        "tourArchived": "Expedición archivada",
        "tourUnarchived": "Expedición restaurada",
        "tourDeleted": "Expedición eliminada",
        "deleteTourConfirm": "¿Eliminar esta expedición? No se puede deshacer.",
        "archiveTourConfirm": "¿Archivar esta expedición? Sale de la lista, pero conserva su registro.",
        "entryCreated": "Movimiento registrado",
        "entryUpdated": "Movimiento actualizado",
        "destroyEntryConfirm": "¿Eliminar este movimiento? No se puede deshacer.",
        "entryDestroyed": "Movimiento eliminado",
        "participantAdded": "Participante añadido",
        "participantRemoved": "Participante eliminado",
        "participantHasEntries": "Elimina antes sus movimientos",
        "settled": "Pagos calculados",
        "reopened": "Libro reabierto",
        "tourCreated": "Expedición creada",
        "tourCreateFailure": "No se pudo crear la expedición.",
        "tourJoined": "Te has unido a la expedición",
        "settleConfirm": "¿Calcular los pagos y bloquear el libro? Los movimientos no se podrán cambiar hasta reabrirlo.",
        "reopenConfirm": "¿Reabrir el libro? Se descartará la lista de pagos actual.",
        "participantNeedsName": "Introduce un usuario o un nombre",
        "weightUpdated": "Parte actualizada",
        "joinRequested": "Tu solicitud fue enviada",
        "joinRequestWithdrawn": "Solicitud retirada",
        "joinRequestApproved": "Solicitud aceptada",
        "joinRequestDeclined": "Solicitud rechazada",
        "expenseApproved": "Gasto aprobado",
        "expenseDeclined": "Gasto rechazado",
        "pendingReview": "%{count} gasto(s) pendientes de revisión"
      },
      "dockAddition": {
        "create": {
          "failure": "No se pudo añadir esa nave."
        },
        "destroy": {
          "failure": "No se pudo quitar esa nave."
        }
      },
      "dockCapacity": {
        "create": {
          "failure": "No se pudo crear la entrada de capacidad."
        },
        "update": {
          "failure": "No se pudo guardar la entrada de capacidad."
        },
        "destroy": {
          "failure": "No se pudo eliminar la entrada de capacidad."
        }
      },
      "dock": {
        "create": {
          "failure": "No se pudo crear el muelle."
        },
        "update": {
          "failure": "No se pudo guardar el muelle."
        },
        "destroy": {
          "failure": "No se pudo eliminar el muelle."
        }
      },
      "relationships": {
        "user": {
          "addHint": "Introduce el nombre de usuario de la persona que quieres añadir. Se le pedirá que acepte."
        },
        "fleet": {
          "addHint": "Introduce el identificador de la flota con la que quieres aliarte. Sus administradores deberán aceptar."
        }
      },
      "friends": {
        "request": {
          "success": "Solicitud enviada",
          "failure": "No se ha podido enviar la solicitud"
        },
        "accept": {
          "success": "Solicitud aceptada",
          "failure": "No se ha podido aceptar la solicitud"
        },
        "decline": {
          "success": "Solicitud rechazada",
          "failure": "No se ha podido rechazar la solicitud"
        },
        "ignore": {
          "success": "Solicitud ignorada",
          "failure": "No se ha podido ignorar la solicitud"
        },
        "remove": {
          "success": "Eliminado",
          "failure": "No se ha podido eliminar"
        }
      },
      "fleetAllies": {
        "request": {
          "success": "Solicitud enviada",
          "failure": "No se ha podido enviar la solicitud"
        },
        "accept": {
          "success": "Solicitud aceptada",
          "failure": "No se ha podido aceptar la solicitud"
        },
        "decline": {
          "success": "Solicitud rechazada",
          "failure": "No se ha podido rechazar la solicitud"
        },
        "ignore": {
          "success": "Solicitud ignorada",
          "failure": "No se ha podido ignorar la solicitud"
        },
        "remove": {
          "success": "Eliminado",
          "failure": "No se ha podido eliminar"
        }
      },
      "vehiclePlaque": {
        "removeConfirm": "¿Quitar la placa de dedicatoria de esta nave?",
        "downloadFailure": "No se pudo guardar la placa como imagen",
        "failure": "No se pudo guardar la placa"
      },
      "vehicleOverview": {
        "image": {
          "success": "Imagen guardada",
          "failure": "No se pudo guardar la imagen"
        },
        "paint": {
          "failure": "No se pudo aplicar la pintura"
        },
        "setting": {
          "failure": "No se pudo guardar el ajuste"
        },
        "location": {
          "failure": "No se pudo guardar la ubicación"
        }
      },
      "vehicleLog": {
        "create": {
          "success": "Entrada añadida",
          "failure": "No se pudo añadir la entrada"
        },
        "update": {
          "success": "Entrada guardada",
          "failure": "No se pudo guardar la entrada"
        },
        "destroy": {
          "failure": "No se pudo eliminar la entrada"
        },
        "defaultUpdate": {
          "failure": "No se pudo guardar el ajuste"
        }
      },
      "vehicleLoadout": {
        "failure": "No se pudo guardar la configuración."
      },
      "hangarPledgeItems": {
        "addedToInventory": {
          "one": "%{count} elemento añadido a %{inventory}",
          "other": "%{count} elementos añadidos a %{inventory}"
        },
        "addToInventoryFailed": "No se pudieron añadir los elementos al inventario."
      }
    }
  }
}
